var map = {
	"./arrow-left-white.svg": 4,
	"./arrow-left.svg": 5,
	"./arrow-right-white.svg": 6,
	"./arrow-right.svg": 7,
	"./arrow-select-rotated.svg": 8,
	"./arrow-select.svg": 9,
	"./badge-adult-hotel.svg": 10,
	"./bed.svg": 11,
	"./butterfly-couple.svg": 12,
	"./butterfly-left.svg": 13,
	"./butterfly-magic-moments.svg": 14,
	"./butterfly-right.svg": 15,
	"./calendar.svg": 16,
	"./camera.svg": 17,
	"./check-brown.svg": 18,
	"./check-orange.svg": 19,
	"./check-pink.svg": 20,
	"./check-turquoise.svg": 21,
	"./check-white.svg": 22,
	"./check.svg": 23,
	"./cup.svg": 24,
	"./dish.svg": 25,
	"./facebook.svg": 26,
	"./filter.svg": 27,
	"./fitted-camera.svg": 28,
	"./fitted-gift-box.svg": 29,
	"./fitted-phone.svg": 30,
	"./gift-box.svg": 31,
	"./highligh-restaurant.svg": 32,
	"./highligh-water-drop.svg": 33,
	"./highlight-breakfast.svg": 34,
	"./insta.svg": 35,
	"./language.svg": 36,
	"./love-arrow-bow.svg": 37,
	"./map-pointer.svg": 38,
	"./minus.svg": 39,
	"./phone.svg": 40,
	"./plus.svg": 41,
	"./pool.svg": 42,
	"./read-more.svg": 43,
	"./room-size.svg": 44,
	"./sample.svg": 45,
	"./wave-big-light-beige.svg": 46,
	"./wave-big-orange.svg": 47,
	"./wave-big-pink.svg": 48,
	"./wave-big-taupe.svg": 49,
	"./wave-big-turquoise.svg": 50,
	"./wave-big.svg": 51,
	"./wave-black.svg": 52,
	"./wave-grafic-white.svg": 53,
	"./wave-grafic.svg": 54,
	"./wave-shallow-big-turquoise.svg": 55,
	"./wave-shallow-small-turquoise.svg": 56,
	"./wave-small-light-beige.svg": 57,
	"./wave-small-orange.svg": 58,
	"./wave-small-pink.svg": 59,
	"./wave-small-taupe.svg": 60,
	"./wave-small-turquoise.svg": 61,
	"./wave-small.svg": 62,
	"./wave-teaser-group.svg": 63,
	"./wave-white.svg": 64,
	"./wave.svg": 65,
	"./youtube.svg": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;